module.exports = __webpack_public_path__ + "img/Metal038_1K_Normal.fd797f00.jpg";